import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

export default function SWUpdateNotification() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setRegistration(e.detail.registration);
      setShowUpdate(true);
    };
    window.addEventListener('swUpdateAvailable', handler);
    return () => window.removeEventListener('swUpdateAvailable', handler);
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] bg-[#0D2850] text-white px-4 py-3 rounded-xl shadow-2xl flex items-center gap-3 animate-in slide-in-from-bottom-4"
      data-testid="sw-update-banner"
    >
      <RefreshCw className="w-4 h-4 animate-spin" />
      <span className="text-sm font-medium">A new version is available</span>
      <button
        onClick={handleUpdate}
        className="bg-white text-[#0D2850] px-3 py-1 rounded-lg text-sm font-semibold hover:bg-slate-100 transition-colors"
        data-testid="sw-update-reload-btn"
      >
        Reload
      </button>
      <button
        onClick={() => setShowUpdate(false)}
        className="text-white/60 hover:text-white text-lg leading-none ml-1"
        data-testid="sw-update-dismiss-btn"
      >
        &times;
      </button>
    </div>
  );
}
